import React from 'react';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  footer
}: ModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm" data-id="element-112">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg overflow-hidden flex flex-col max-h-[90vh]" data-id="element-113">
        <div className="flex items-center justify-between p-4 border-b border-slate-100" data-id="element-114">
          <h3 className="text-lg font-bold text-slate-800" data-id="element-115">{title}</h3>
          <button onClick={onClose} className="p-1 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-full transition-colors" data-id="element-116">
            <XIcon className="w-5 h-5" data-id="element-117" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto flex-1" data-id="element-118">{children}</div>
        {footer && <div className="p-4 border-t border-slate-100 bg-slate-50 flex justify-end gap-3" data-id="element-119">
            {footer}
          </div>}
      </div>
    </div>;
}